import { useState } from 'react';
import NoteIcon from '../assets/note.svg';
import InfoIcon from '../assets/info.svg';
import { InfoModal } from './InfoModal';
import { GamesRoutes, useAppContext, VRoute } from '../context';

export const headerStyles = {
    iconBox: 'w-[46px] h-[46px] absolute top-4 p-3 rounded-lg '
}


const BGs: Record<GamesRoutes, string> = {
    quiz: '/images/interview/header.webp',
    foodtest: '/images/test/header.webp',
    chat: 'none',
}

export const Header = () => {
    const [showInfo, setShowInfo] = useState(false);
    const { currentRoute, musicPlay, switchMusicPlay, isMobile } = useAppContext();

    const toggleShowInfo = () => {
        setShowInfo((prev) => !prev)
    }

    return isMobile ? (
        <div
            className={`absolute top-0 left-0 right-0 h-[180px] short:h-[130px] bg-cover bg-top select-none`}
            style={{ backgroundImage: BGs[currentRoute as GamesRoutes] !== 'none' ? `url(${BGs[currentRoute as GamesRoutes]})` : '' }}
            key={currentRoute}
        >
            <header className="absolute top-0 left-0 right-0 flex justify-between p-4 z-50 max-w-md mx-auto select-none">
                {currentRoute as VRoute !== 'result' && <>
                    <button
                        onClick={switchMusicPlay}
                        className={`${headerStyles.iconBox} left-4 bg-white`}
                    >
                        {!musicPlay && (
                            <svg className='absolute top-[6px] left-[6px]' width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.53516 3.53552L10.6062 10.6066" stroke="#2DBC64" strokeWidth="1.4" strokeLinecap="round" />
                                <path d="M3.53516 10.6066L10.6062 3.5355" stroke="#2DBC64" strokeWidth="1.4" strokeLinecap="round" />
                            </svg>
                        )}
                        <img src={NoteIcon} alt="Звук" className='mx-auto' />
                    </button>

                    {currentRoute as VRoute !== 'start' && <button
                        onClick={toggleShowInfo}
                        className={`${headerStyles.iconBox} right-4 bg-white`}
                    >
                        <img src={InfoIcon} alt="Инфо" className='mx-auto' />
                    </button>}
                </>
                }

                <InfoModal isShow={showInfo} toggleShow={toggleShowInfo} />

            </header>
        </ div>
    ) : <header key={currentRoute} className={`absolute top-0 left-0 right-0 elect-none z-50 p-8`}>
        <button
            onClick={switchMusicPlay}
            className={`w-[46px] h-[46px] p-3 rounded-lg bg-white relative`}
        >
            {!musicPlay && (
                <svg className='absolute top-[6px] left-[6px]' width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.53516 3.53552L10.6062 10.6066" stroke="#2DBC64" strokeWidth="1.4" strokeLinecap="round" />
                    <path d="M3.53516 10.6066L10.6062 3.5355" stroke="#2DBC64" strokeWidth="1.4" strokeLinecap="round" />
                </svg>
            )}
            <img src={NoteIcon} alt="Звук" className='mx-auto' />
        </button>
    </header>;
};
